module.exports = __webpack_public_path__ + "28aa3c1c9bfee93ea6c057835d9c921f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/alipay_active.png
// module id = 581
// module chunks = 0